import React from 'react';
import { Field } from 'redux-form';
import cx from 'classnames';
import range from 'lodash.range';
import Input from '../Forms/Input';
import SelectField from '../Forms/SelectField';
import styles from './AdditionalInformationFields.css';
import required from '../../utils/fieldRequired';
import trimWhiteSpace from '../../utils/trimWhiteSpace';
import states from '../../../constants/states';

const emptyOption = {
    value: '',
    text: '',
    key: -1,
};

const graduationYearOptions = range(2030, 2020).map(i => ({
    value: i,
    text: i,
    key: i,
}));

const datesOptions = range(2020, 1930).map(i => ({
    value: i,
    text: i,
    key: i,
}));
graduationYearOptions.unshift(emptyOption);

const optionsForStates = Object.keys(states).map(value => ({
    value,
    text: value,
    key: value,
}));
optionsForStates.unshift(emptyOption);


const validateMobile = (value) => {
    if (value == null || trimWhiteSpace(value) === '') {
        return undefined;
    }

    if (!/^\d{10}$/.test(value)) {
        return 'Please enter valid phone number';
    }
    return undefined;
};

const NorthWestAdditionalInformationFields = () => (<div>
    <div className={styles.row}>
        <Field
            name="dateOfBirth"
            label="Date of Birth"
            component={Input}
            mask="mm/dd/yyyy"
            placeholder="mm/dd/yyyy"
            className={styles.input}
            validate={required}
            options={datesOptions}
        />
        <Field
            name="expectedGraduationYear"
            label="Expected HS Graduation Year"
            component={SelectField}
            className={styles.input}
            validate={required}
            options={graduationYearOptions}
        />
    </div>
    <div className={styles.row}>
        <Field
            name="mobilePhone"
            label="Mobile Phone"
            component={Input}
            className={styles.input}
            validate={validateMobile}
        />
    </div>
    <div className={styles.row}>
        <Field
            name="streetAddress"
            label="Street Address"
            component={Input}
            className={cx(styles.input, styles.size7)}
            validate={required}
        />
        <Field
            name="unit"
            label={<span>
                Unit <span className={styles.optional}>(OPTIONAL)</span>
            </span>}
            component={Input}
            className={cx(styles.input, styles.size3)}
        />
    </div>
    <div className={styles.row}>
        <Field
            name="city"
            label="City"
            component={Input}
            className={cx(styles.input, styles.size8)}
            validate={required}
        />
        <Field
            name="state"
            label="State"
            component={SelectField}
            className={cx(styles.input, styles.size2)}
            options={optionsForStates}
            validate={required}
        />
    </div>
    <div className={styles.row}>
        <Field
            name="currentInstitution"
            label="Name in educational institution currently enrolled"
            component={Input}
            className={styles.input}
            validate={required}
        />
    </div>
</div>);

NorthWestAdditionalInformationFields.propTypes = {};

export default NorthWestAdditionalInformationFields;



// WEBPACK FOOTER //
// ./src/client/Components/ExtraUserInformation/NorthWestAdditionalInformationFields.js